import { ReactElement, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import Dashboard from './pages/Dashboard/Dashboard';
import FileCreationWrapper from './pages/FileCreationWrapper/FileCreationWrapper';
import ProseedSubmission from './pages/ProseedSubmission/ProseedSubmission';
import {TUserCompanyConfigItem} from "../../@types/global";

type File83bRoutesPropTypes = {
    filingCreationEnabled: boolean;
    templateSpouseCode?: string;
    paymentEnabled: boolean;
    isEveryCompany: boolean;
    templateCrypto: string;
    templateCode: string;
    companyId: number;
    fullName: string;
    userId: number;
    email: string;
    deliveryService: string;
    companies: TUserCompanyConfigItem[],
    isAdminRole: boolean;
    isOpenAiCompany: boolean;
}

function File83bRoutes(props: File83bRoutesPropTypes): ReactElement {
    const {
        email,
        userId,
        fullName,
        companies,
        companyId,
        isAdminRole,
        templateCode,
        templateCrypto,
        paymentEnabled,
        isEveryCompany,
        templateSpouseCode,
        deliveryService,
        isOpenAiCompany,
        filingCreationEnabled,
    } = props;



    return (
        <Routes>
            <Route
                path="/"
                element={
                    <Dashboard
                        userId={userId}
                        companyId={companyId}
                        companies={companies}
                        isAdminRole={isAdminRole}
                        filingCreationEnabled={filingCreationEnabled} />
                } />
            <Route
                path="/file-83b"
                element={
                    <FileCreationWrapper
                        companies={companies}
                        email={email}
                        fullName={fullName}
                        companyId={companyId}
                        deliveryService={deliveryService}
                        templateCode={templateCode}
                        templateCrypto={templateCrypto}
                        paymentEnabled={paymentEnabled}
                        isEveryCompany={isEveryCompany}
                        isOpenAiCompany={isOpenAiCompany}
                        templateSpouseCode={templateSpouseCode}
                        filingCreationEnabled={filingCreationEnabled}
                    />
                } />
            <Route
                path="/file-83b/continue"
                element={
                    <ProseedSubmission
                        companyId={companyId}
                        paymentEnabled={paymentEnabled}
                        filingCreationEnabled={filingCreationEnabled}
                    />
                } />
        </Routes>
    );
}

export default File83bRoutes;